import { useTheme, useMediaQuery, Breakpoint } from "@mui/material";

export const useMediaBreakpoint = (upDown: "up" | "down", breakpoint: Breakpoint): boolean => {
    const theme = useTheme();
    return useMediaQuery(upDown === "up" ? theme.breakpoints.up(breakpoint) : theme.breakpoints.down(breakpoint));
}